import { Component, inject, OnInit } from '@angular/core';
import { Animations, DankeComponent, GoogleTagManagerService } from '@vhv/tarifrechner-common';
import { StartComponent } from '../start/start.component';


@Component({
    animations: [Animations.slideInDownAnimation],
    templateUrl: "baugeraete-danke.component.html"
})
export class BaugeraeteDankeComponent extends DankeComponent implements OnInit{
    googleTagManagerService: GoogleTagManagerService = inject(GoogleTagManagerService)
    ngOnInit(): void {
        super.ngOnInit();
        window.removeEventListener("beforeunload", StartComponent.createMessageBeforeUnload);
        this.googleTagManagerService.sendAbschlussRechnerschrittEvent("baugeraete")
    }
}
